import React from 'react';

import { TestimonialType } from '../../../../CreateAccountModal/types';
import {
  adobeLogoSrc,
  feedbackAuthorAvatarSrc,
} from '../../../../CreateAccountModal/CreateAccountModalContentArea/images';
import './SocialProof.scss';

const defaultTestimonial = {
  authorAvatarSrc: feedbackAuthorAvatarSrc,
  authorName: 'Mary Sheehan',
  address: 'Sr. Manager of PMM at',
  orgLogoSrc: adobeLogoSrc,
  feedback:
    'Now more than ever, managers must have systems in place that ensure clear communication and alignment across their team.',
};

type Props = {
  testimonial?: TestimonialType;
};

function SocialProof({
  testimonial: { authorAvatarSrc, authorName, address, orgLogoSrc, feedback } = defaultTestimonial,
}: Props) {
  return (
    <div className="SocialProof">
      <div className="d-flex align-items-center">
        <img className="mr-2" width="35" src={authorAvatarSrc} alt={authorAvatarSrc} />
        <div className="SocialProof__author-name">{authorName}</div>
      </div>

      <div className="SocialProof__address d-flex my-2">
        {address}
        {orgLogoSrc && <img className="ml-2 align-self-center" width="70" src={orgLogoSrc} alt={orgLogoSrc} />}
      </div>
      <p className="SocialProof__feedback pr-1 mb-0">“{feedback}”</p>
    </div>
  );
}

export default SocialProof;
